import { yupResolver } from '@hookform/resolvers/yup'
import { TextField } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import Stack from '@mui/material/Stack'
import axios from 'axios'
import { useSnackbar } from 'notistack'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'

import { createBlogCategory } from '../../../services/blogCategoriesService'
import type { NewBlogCategory } from '../../../types/BlogCategory'

interface NewBlogCategoryModalProps {
	open: boolean
	setOpen: React.Dispatch<React.SetStateAction<boolean>>
	refetch: () => void
}

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '20%',
	height: '40%',
	bgcolor: 'background.paper',
	border: '1px solid #000',
	borderRadius: '10px',
	boxShadow: 24,
	p: 2,
	'@media(max-width: 425px)': {
		width: '90%',
	},
}

const schema = yup.object().shape({
	name: yup.string().required('O campo Nome não pode ser vazio'),
	slug: yup.string().notRequired(),
	description: yup.string().notRequired(),
})

function NewBlogCategoryModal({
	open,
	setOpen,
	refetch,
}: NewBlogCategoryModalProps) {
	const { enqueueSnackbar } = useSnackbar()

	const handleClose = () => {
		setOpen(false)
	}

	const {
		control,
		formState: { errors },
		handleSubmit,
	} = useForm<NewBlogCategory>({
		resolver: yupResolver(schema),
	})

	const submit = async (data: NewBlogCategory) => {
		try {
			await createBlogCategory(data)
			refetch()
			enqueueSnackbar('Categoria criada', { variant: 'success' })
			handleClose()
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const message = err?.response?.data.message
				enqueueSnackbar(message, { variant: 'error' })
			}
		}
	}

	return (
		<Modal open={open} onClose={handleClose}>
			<Box sx={style}>
				<form onSubmit={handleSubmit(submit)} style={{ height: '100%' }}>
					<Stack
						direction='column'
						justifyContent='space-between'
						sx={{ height: '100%' }}
					>
						<Stack direction='column' gap={1}>
							<Controller
								name='name'
								control={control}
								render={({ field: { onChange } }) => (
									<TextField
										size='small'
										label='Nome'
										onChange={onChange}
										error={Boolean(errors?.name)}
										helperText={errors?.name?.message}
									/>
								)}
							/>
							<TextField disabled size='small' label='Slug (autopreenchido)' />
							<Controller
								name='description'
								control={control}
								render={({ field: { onChange } }) => (
									<TextField
										size='small'
										label='Descrição (opcional)'
										multiline
										onChange={onChange}
										maxRows={6}
									/>
								)}
							/>
						</Stack>
						<Button
							type='submit'
							title='Criar categoria'
							fullWidth
							variant='contained'
						>
							Criar
						</Button>
					</Stack>
				</form>
			</Box>
		</Modal>
	)
}

export default NewBlogCategoryModal
